<template>
  <b-overlay
    :show="loading"
    spinner-variant="primary"
    spinner-type="grow"
    spinner-small
    rounded="sm"
  >
    <!-- Breadcrumb -->
    <app-breadcrumb>
      <template #contentright>
        <b-button
          v-if="$route.params.id !== undefined"
          variant="success"
          :to="{ name: 'modules-add' }"
        >
          <span class="text-nowrap">
            <feather-icon icon="PlusCircleIcon" /> {{ $t('Add New') }}
          </span>
        </b-button>
        <span v-else />
      </template>
    </app-breadcrumb>
    <b-row>
      <b-col md="6">
        <b-card aria-hidden="true">
          <!-- Alert: No item found -->
          <b-alert
            variant="danger"
            :show="errorMessage !== ''"
          >
            <h4 class="alert-heading">
              {{ errorMessage }}
            </h4>

          </b-alert>

          <!-- BODY -->
          <validation-observer
            #default="{ handleSubmit }"
            ref="refFormObserver"
          >
            <!-- Form -->
            <b-form
              class=""
              @submit.prevent="handleSubmit(onSubmit)"
              @reset.prevent="resetForm"
            >
              <!-- Name -->
              <validation-provider
                #default="validationContext"
                :name="$t('Name')"
                rules="required|alpha-num|max:150"
              >
                <b-form-group>
                  <template #label>
                    <label class="d-block font-weight-bolder">{{ $t('Name') }} <span class="text-danger">*</span></label>
                  </template>
                  <b-form-input
                    id="name"
                    v-model="itemData.name"
                    :state="getValidationState(validationContext)"
                    trim
                  />

                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>

              <!-- Description -->
              <validation-provider
                #default="validationContext"
                :name="$t('Description')"
                rules="required|max:150"
              >
                <b-form-group>
                  <template #label>
                    <label class="d-block font-weight-bolder">{{ $t('Description') }} <span class="text-danger">*</span></label>
                  </template>
                  <b-form-input
                    id="description"
                    v-model="itemData.description"
                    :state="getValidationState(validationContext)"
                  />

                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>

              <!-- route -->
              <validation-provider
                #default="validationContext"
                :name="$t('Route')"
                rules="required|max:250"
              >
                <b-form-group>
                  <template #label>
                    <label class="d-block font-weight-bolder">{{ $t('Route') }} <span class="text-danger">*</span></label>
                  </template>
                  <b-form-input
                    id="route"
                    v-model="itemData.route"
                    :state="getValidationState(validationContext)"
                  />

                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>

              <!-- Form Actions -->
              <div class="d-flex mt-2">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  class="mr-2"
                  type="submit"
                >
                  {{ $t('Save') }}
                </b-button>
              </div>

            </b-form>
          </validation-observer>
        </b-card>

      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>
import {
  BRow, BCol, BCard, BCardHeader, BCardTitle, BAlert, BOverlay, BForm, BFormGroup, BButton, BFormInput, BFormInvalidFeedback, BTable, BFormCheckbox,
  BFormTextarea,
} from 'bootstrap-vue'
import {
  ref, watch,
} from '@vue/composition-api'
import store from '@/store'
import { useRouter, showToast } from '@core/utils/utils';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  required, alphaNum, alphaNumDot, max, integer,
} from '@validations';
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'

export default {
  components: {
    AppBreadcrumb,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BAlert,
    BOverlay,
    BForm,
    BFormGroup,
    BButton,
    BFormInput,
    BTable,
    BFormInvalidFeedback,
    BFormCheckbox,
    BFormTextarea,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      required,
      integer,
      alphaNum,
      alphaNumDot,
      max,
    }
  },
  computed: {

  },
  // watch: {
  //   $route(to, from) {
  //     if (to.name === 'modules-add') {
  //       this.resetItemData();
  //     } else {
  //       this.fetchData();
  //     }
  //   },
  // },
  setup(props, context) {
    const { route, router } = useRouter();
    const id = ref(route.value.params.id !== undefined ? route.value.params.id : 0);
    const layout = ref(route.value.name !== 'modules-edit' ? 'add' : 'edit');
    const loading = ref(!!id.value)
    const errorMessage = ref('')
    const modules = ref([])
    const defaultItemData = {
      name: '',
      description: '',
      route: '',
      settings: '',
      position: 1,
    }
    const itemData = ref(JSON.parse(JSON.stringify(defaultItemData)))

    const resetItemData = () => {
      itemData.value = JSON.parse(JSON.stringify(defaultItemData))
    }
    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetItemData)

    const onSubmit = () => {
      errorMessage.value = '';
      loading.value = true;

      if (layout.value === 'edit') {
        store.dispatch('modules/updateModule', { id: id.value, data: itemData.value })
          .then((response) => {
            loading.value = false
            if (response.status === 200) {
              if (response.data.code === 200) {
                showToast(response.data.message, { variant: 'success' });
                router.push({ name: 'modules-list' })
              } else {
                showToast(response.data.message)
                errorMessage.value = response.data.message;
              }
            }
          })
      } else {
        store.dispatch('modules/addModule', itemData.value)
          .then((response) => {
            loading.value = false
            if (response.status === 200) {
              if (response.data.code === 200) {
                showToast(response.data.message, { variant: 'success' });
                router.push({ name: 'modules-list' })
              } else {
                showToast(response.data.message)
                errorMessage.value = response.data.message;
              }
            }
          })
      }
    }

    const fetchData = () => {
      loading.value = true;
      store.dispatch('modules/fetchModule', { id: id.value })
        .then(response => {
          if (response.status === 200) {
            itemData.value = response.data.data
            loading.value = false
            errorMessage.value = '';
          } else {
            errorMessage.value = response.message
            loading.value = false
          }
        })
    }
    if (id.value && layout.value === 'edit') {
      fetchData();
    }

    watch(
      () => context.root.$route,
      (to) => {
        if (to.name === 'modules-add') {
          resetItemData();
        } else {
          fetchData();
        }
      },
    )

    return {
      id,
      layout,
      errorMessage,
      loading,
      itemData,
      modules,
      refFormObserver,
      getValidationState,
      resetForm,
      resetItemData,
      onSubmit,
      fetchData,
    }
  },

}
</script>

<style></style>
